<ng-container *ngIf="accountAssessment?.assessmentType == 'NIST'">
  <div style="padding-bottom:20px">
    <app-risk-selector [assessment]="accountAssessment" (nistFunctionSelector)="selectNistFunction($event)"></app-risk-selector>
  </div>
  <mat-grid-list cols="3" gutterSize="20px" style="height:auto;">
    <mat-grid-tile colspan="2">
      <app-riskmap
        [assessment]="accountAssessment"
        [selectedNistFunction]="selectedNistFunction"
        (nistSubCategorySelector)="selectNistSubCategory($event)">
      </app-riskmap>
    </mat-grid-tile>
    <mat-grid-tile>
      <app-category-risk
        [assessment]="accountAssessment"
        [selectedNistFunction]="selectedNistFunction"
        [questionDetailSelection]="questionDetailSelection"
        (nistSubCategorySelector)="selectNistSubCategory($event)">
      </app-category-risk>
    </mat-grid-tile>
    <mat-grid-tile colspan="3" *ngIf="accountAssessment && questionDetailSelection?.nistFunction && questionDetailSelection?.nistSubCategory">
      <app-subsection-detail
        [accountAssessment]="accountAssessment"
        [questionDetailSelection]="questionDetailSelection">
      </app-subsection-detail>
    </mat-grid-tile>
  </mat-grid-list>
</ng-container>
<ng-container *ngIf="accountAssessment?.assessmentType != 'NIST'">
  <cw-ci-assessment-work  [account]='account' [accountAssessment]='accountAssessment' [assmntReadOnly]=true></cw-ci-assessment-work>
</ng-container>
